export default {
    page_title: "매출",
};
